import { Component } from '@angular/core';

@Component({
  selector: 'app-paymentmethods',
  templateUrl: './paymentmethods.component.html',
  styleUrls: ['./paymentmethods.component.scss'],
})
export class PaymentmethodsComponent {}
